<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em;; padding-top:15px;">Sarah lives in Hertfordshire with her husband and two grown up children.</p>
<p style="text-indent:00em;; padding-top:15px;">She has had a varied career, including a short stint in the police force; a residential social worker, and for 18 years as a teaching assistant in a special needs school. Sarah also volunteered for her local hospice. She enjoys all things creative, and can often be found in her shed with various ideas buzzing around her head.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?421bd9cc